import type {
	Elements,
	ElementModels,
	IContentItem,
} from '@kontent-ai/delivery-sdk'
import {useRouter} from 'next/router'
import {addLocalePrefix} from '@/utilities/add-locale-prefix'
import type {Block} from '@/services/kontent-ai/types'
import {CarouselCTA} from '../../components/carousel/carousel-cta'
import {CarouselCTABlock as Carousel} from '../../components/carousel/carousel-cta-block'

const ALLOWED_HEADING_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const
type HeadingTag = (typeof ALLOWED_HEADING_TAGS)[number]

export type CarouselCtaContentItem = IContentItem<{
	title: Elements.TextElement
	link: Elements.TextElement
	icon: Elements.AssetsElement
}>

export type CarouselCtaBlockContentItem = IContentItem<{
	title: Elements.TextElement
	titleTag: Elements.MultipleChoiceElement
	subtitle: Elements.TextElement
	carouselCtas: Elements.LinkedItemsElement<CarouselCtaContentItem>
}>

export const CarouselCTABlockBlock: Block<CarouselCtaBlockContentItem> = ({
	block,
}) => {
	const {locale = ''} = useRouter()
	const titleTagOptions = block.elements.titleTag as
		| ElementModels.MultipleChoiceOption[]
		| undefined
	const selectedCodename = titleTagOptions?.[0]?.codename
	const selectedTag: HeadingTag = ALLOWED_HEADING_TAGS.includes(
		selectedCodename as HeadingTag
	)
		? (selectedCodename as HeadingTag)
		: 'h1'

	return (
		<Carousel
			subtitle={block.elements.subtitle}
			title={block.elements.title}
			titleTag={selectedTag}
		>
			{block.elements.carouselCtas.map((cta) => (
				<CarouselCTA
					icon={cta.elements.icon}
					key={cta.elements.title}
					link={addLocalePrefix(cta.elements.link, locale)}
					title={cta.elements.title}
				/>
			))}
		</Carousel>
	)
}
